import { styled } from 'styled-components';
import ReadyStartBg from '@/assets/images/home/ready-start-bg.png';
import ReadyStartMobileBg from '@/assets/images/home/bg-mobile-ready-start.png';
import { breakpoints } from '@/config/breakpoints';

export const Wrapper = styled.div`
  width: 100%;
  background: url(${ReadyStartBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  @media screen and (max-width: ${breakpoints.md}) {
    padding-top: 115px;
    background: url(${ReadyStartMobileBg});
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1176px;
  margin: 0 auto;
  padding: 117px 24px 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  p,
  span {
    text-align: center;
  }
  @media screen and (max-width: ${breakpoints.md}) {
    padding: 0 16px;
    gap: 15px;
  }
`;

export const ButtonWrapper = styled.div`
  padding: 8px 8px;

  p {
    margin: 0px;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    padding: 8px 0px;
  }
`;

export const Description = styled.p`
  color: #fff;
  text-align: center;

  /* Subhead/Subhead 1/Regular */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  margin-bottom: 32px;
`;
